import BaseModel from "../BaseModel";
import LicenseType from "./LicenseType";
import Customer from "./Customer";

export default class License extends BaseModel{
    static entity = 'licenses';
    static fields(){
        return {
            id: this.attr(null),
            customer_id: this.attr(null),
            license: this.attr(null),
            license_type_id: this.attr(null),
            user_id: this.attr(null),
            license_type: this.belongsTo(LicenseType, 'license_type_id'),
            customer: this.belongsTo(Customer, 'customer_id')
        }
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at', 'license_type', 'customer']
    }
    static route(){
        return '/licenses'
    }
}
